import {hasPermission, useUser} from "../../../../misc/Permission";
import {
    RenderStringCol,
    RenderStringCol2,
    StringCol,
    Table, ViewOnly,
} from "../../../../misc/scroller/Table";
import {priceTableName} from "./Pricing";
import {useProjectId} from "../ProjectName";
import React, {useContext} from "react";
import {ManagerLockContext} from "../ProjectActions";
import {PriceLine2,} from "./Frames";
import {
    commonPricingColumns3,
    commonPricingColumns3Start,
    sovCellCustomize,
    sovColumns,
    usePricingKit2
} from "./usePricingKit2";
import {getAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {FakeLink} from "../../../../misc/FakeLink";
import {ProductEditFromId} from "../extras/ProductEdit";
import {SidePricingPanel} from "./SidePricingPanel";
import {onPricingChangeWrap} from "./PricingTabs";
import {useCheckboxExtSetupData} from "../../manage/sov/CheckboxExtProvider";
import {ucWords} from "./PriceRequestSubmittal";

export function Hardware(props: {
    kind: string;
    filterByChangeset?: boolean;
    sov?: number;
}) {
    const project = useProjectId();
    const {locked} = useContext(ManagerLockContext)
    const u = useUser();

    const kit = usePricingKit2(project);
    const [showProduct, setShowProduct] = React.useState<number|null>(null);
    const checkboxAllData = useCheckboxExtSetupData();

    if(!u) return null;
    if(kit.Loading) return <>{kit.Loading}</>

    const tableName = priceTableName(project, props.kind);

    return (
        <div style={{display: "flex", flex: 1, flexDirection: "row", alignItems: "stretch"}}>
            <Table<PriceLine2>
                name={tableName}
                globalPrefsName={priceTableName(0, props.kind)}
                cellCustomize={
                    props.sov ? sovCellCustomize(props.sov) :
                        props.filterByChangeset ?
                            undefined :
                            kit.cellCustomize
                }
                locked={locked && !hasPermission(u, "EditShopDrawingWhenLockedToManager")}
                fetch={async (ctx) => checkboxAllData(getAll(ctx, offset =>
                    api.pricing.list({
                        project: project, offset,
                        previewChangeset: kit.sessionId,
                        category: props.kind as any,
                        filterByChangeset: props.filterByChangeset,
                        refunded: props.filterByChangeset ? false : undefined,
                        forSovLink: !!props.sov,
                    })
                ))}
                columns={[
                    ...sovColumns(props.sov),
                    ...commonPricingColumns3Start(),
                    RenderStringCol2<PriceLine2>("Name",
                            o => {
                                if(o.productCode === "Keying") return o.manufacturerName + " - Keying";
                                return o.productCategoryName || ""
                            },
                            o => {
                                if(o.productCode === "Keying") return o.manufacturerName + " - Keying";

                                return (
                                    <FakeLink onClick={() => setShowProduct(o.product)}>
                                        {o.productCategoryName || ""}
                                    </FakeLink>
                                )
                    }),
                    RenderStringCol<PriceLine2>("Code", o => {
                        if(o.productCode === "Keying" && o.keyingType) return `${o.productCode} (${ucWords(o.keyingType.replace("-", " "))})`;
                        return o.productCode;
                    }),
                    ViewOnly(StringCol("Dim", "dimensions")),
                    ...commonPricingColumns3(u, kit.markup?.frame + "%", props.sov),
                ]}
                columnDeps={[u, kit.markup, props.sov]}
                fetchDeps={[project, kit.sessionId, props.kind, props.filterByChangeset, props.sov]}
                onChange={(input) => onPricingChangeWrap(api.pricing.upsert(input))}
            />
            {showProduct && <ProductEditFromId
                id={showProduct} mode="hardware"
                onClose={() => {
                setShowProduct(null);
            }} />}
            {props.filterByChangeset && <SidePricingPanel
                kind={props.kind === "hardware" ? "hardware" : "frame-anchor"}
                preColumns={[
                    RenderStringCol<PriceLine2>("Name", o => o.productCategoryName || ""),
                    ViewOnly(StringCol("Code", "productCode")),
                    ViewOnly(StringCol("Dim", "dimensions")),
                    ViewOnly(StringCol("Side", "openingSubtype")),
                ]}
            />}
        </div>
    )
}
